export const PRESET_TYPES = Object.freeze({
  DEFAULT: 'DEFAULT',
  CUSTOM: 'CUSTOM',
  EMPTY: 'EMPTY'
});